import Icon from '@katalon-studio/katalon-ui/Icon';
import React from 'react';
import colors from '../../../scss/colors.scss';

function PenIcon(props) {
  const { color, textSize, type } = props;
  return <Icon
    type={`fa-${type}`}
    name="fa-pen"
    textSize={textSize}
    sx={{
      color,
    }}
    boundingSize={null}
    color={null}
  />;
}

PenIcon.defaultProps = {
  color: colors.gray9,
  textSize: '14px',
  type: 'regular',
};

export default PenIcon;
